import favicon from '../../assets/favicon.png'

export default favicon
